// Acordeones de la ficha: abren y cierran con animación de altura y uno a la vez
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ease = 'cubic-bezier(0.23, 1, 0.32, 1)';
  const index = (d) => d.querySelectorAll('.tbx-acc__inner > *, .tbx-acc__inner li').forEach((el, i) => el.style.setProperty('--i', i));

  function animate(details, open) {
    const body = details.querySelector('.tbx-acc__body');
    details._target = open;
    if (details._anim) details._anim.cancel();
    if (reduce || !body.animate) { details.open = open; return; }
    const start = open ? 0 : body.offsetHeight;
    if (open) details.open = true;
    const end = open ? body.scrollHeight : 0;
    details._anim = body.animate({ height: [start + 'px', end + 'px'] }, { duration: open ? 420 : 300, easing: ease });
    details._anim.onfinish = () => { details._anim = null; if (!open) details.open = false; };
  }

  function init(root) {
    const all = [...root.querySelectorAll('.tbx-acc details')];
    all.forEach((d) => {
      if (d._tbx) return; d._tbx = true;
      index(d);
      d.querySelector('summary').addEventListener('click', (e) => {
        e.preventDefault();
        const opening = d._anim ? !d._target : !d.open;
        if (opening) all.forEach((o) => { if (o !== d && (o._anim ? o._target : o.open)) animate(o, false); });
        animate(d, opening);
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
